<template>
<b-row class="ted-flares2 no-gutters">

    <b-col class="tool-border" cols="12">
        <tedtfHeader :image="'triggers'" :screenTitle="'Triggers for TED Flares'"></tedtfHeader>
        <b-col class="page-background-gradient reduce-padding" cols="12">
            <b-row class="page-content no-gutters">
                <div class="body-sec">
                    <b-row class="no-gutters"> 
                       <b-col class="reduce-padding" cols="12">
                            <div class="main-text">
                                The following are potential triggers for TED flares.<br>
                              Please check the box if any of the following 9 questions are true for you:
                            </div>
                        </b-col>
                   <b-col class="reduce-padding" cols="12"> 
                   <b-row class="no-gutters">
                    <b-col class="reduce-padding" cols="12">
                   <b-row class="no-gutters">
                   <b-col class="reduce-padding" lg="7" md="8" sm="12">
                   <div class="ques-sec">
                   <div class="medicine-image"></div>
                   <div class="radioactive-heading">Do you take or have you taken radioactive iodine (RAI) in the past?</div>
                   <b-row class="checkbox-area">

                    <b-col cols="6" class="reduce-padding">
                    <div class="ted-radio ">
                    <input @click="tagInput('RAI', 'Yes' )" type="radio" name="radioActiveIodineYes" v-model="userData.radioActiveIodine" id="radioActiveIodineYes" value="radioActiveIodineYes">
                        <label for="radioActiveIodineYes">
                    <div class="checkbox-label">YES</div>
                     </label>
                        </div>
                    </b-col>

                                  <b-col cols="6" class="reduce-padding">
                              <div class="ted-radio top-margin">
                               <input @click="tagInput('RAI', 'No' )" type="radio" name="radioActiveIodineNo" v-model="userData.radioActiveIodine" id="radioActiveIodineNo" value="radioActiveIodineNo">
                                <label class="no-label" for="radioActiveIodineNo">
                                <div class="checkbox-label">NO</div>
                                    </label>
                                </div>
                               </b-col>
                        </b-row>
                                   </div>
                               </b-col>
                                 <b-col class="reduce-padding" lg="5" md="4" sm="12">
                                            <div class="right-box ">
                                                <div class="box"><p class="box-inside-text">Radioactive iodine increases the risk of a TED flare by 3.5 - 19.5x.</p></div>
                                            </div>
                                        </b-col>
                                        
                           </b-row>
                       </b-col>
                   </b-row>
                          <hr class="horizontal-line">
                          
                           <b-row class="no-gutters row-margin">
                    <b-col class="reduce-padding" cols="12">
                   <b-row class="no-gutters">
                   <b-col class="reduce-padding" lg="7" md="8" sm="12">
                   <div class="ques-sec">
                   <div class="avoid-eye"></div>
                   <div class="eye-heading">Have you recently had any eye trauma or surgery (such as cataract surgery)?</div>
                   <b-row class="checkbox-area">

                    <b-col cols="6" class="reduce-padding">
                    <div class="ted-radio ">
                    <input @click="tagInput('Trauma', 'Yes' )" type="radio" name="eyeTraumaYes" v-model="userData.eyeTrauma" id="eyeTraumaYes" value="eyeTraumaYes">
                        <label for="eyeTraumaYes">
                    <div class="checkbox-label">YES</div>
                     </label>
                        </div>
                    </b-col>

                    <b-col cols="6" class="reduce-padding">
                    <div class="ted-radio top-margin">
                        <input @click="tagInput('Trauma', 'No' )" type="radio" name="eyeTraumaNo" v-model="userData.eyeTrauma" id="eyeTraumaNo" value="eyeTraumaNo">
                        <label class="no-label" for="eyeTraumaNo">
                    <div class="checkbox-label">NO</div>
                </label>
                </div>
                </b-col>
                </b-row>
              </div>
              </b-col>
                 <b-col class="reduce-padding" lg="5" md="4" sm="12">
                <div class="right-box ">
                    <div class="box"><p class="inside-box-text">TED flares, such as inflammation (ie pain, redness, swelling), can be triggered with a trauma.</p></div>
                    </div>
            </b-col>
                                        
                           </b-row>
                       </b-col>
                   </b-row>
                  </b-col>
                  </b-row>
                </div>
            </b-row>
        </b-col>
        <tedftNavigation v-bind:navButtons="['next','back', 'showMidCol']" :currentScreen="5"  :isSymptom="true" :isHideMenu="false"></tedftNavigation>
    </b-col>

</b-row>
</template>
<script>
    /* eslint-disable */
    import { mapGetters } from 'vuex';
import taggingMixin from "../mixins/taggingMixin";
    import tedtfHeader from '../components/tedtfHeader.vue';
    import tedftNavigation from '../components/tedftNavigation.vue';

    export default {
        name: "tedFlares2",
        mixins: [taggingMixin],
        mounted: function() {
        },
        components: {
            'tedtfHeader': tedtfHeader,
            'tedftNavigation': tedftNavigation
        },

        computed: {
             ...mapGetters('userData', ['userData'])
        },

        methods: {
        },

        data() {
            return {};
        },
    };
</script>


<style lang="scss" scoped>
</style>
